import { LeftMostPaneStoreType } from 'components/WorkspaceEditor/types/types'
import { ElementPanelSubItem } from 'models/projectElements'
import { create } from 'zustand'

/**
 * Creates a zustand store for managing elements tree  state
 */
export const useElementTreeStore = create<LeftMostPaneStoreType>()((set) => ({
    showLeftMostPane: true,
    selectedElementFilterType: {} as ElementPanelSubItem,
    currentPane: 'elements',
    updateElementPanelState: false,
    isSearchBarDisplayed: true,
    setshowLeftMostPane: (value) => {
        set({ showLeftMostPane: value })
    },

    setCurrentPane: (value) => {
        set({ currentPane: value })
    },
    setUpdateElementPanelState: (value) => {
        set({ updateElementPanelState: value })
    },
    setIsSearchBarDisplayed: (value) => {
        set({ isSearchBarDisplayed: value })
    },
}))
